import { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { Flex } from 'reflexbox';

import { IEitherNavigationLink } from 'packages/kakapo-ui-kit/types/Navigation';

interface IElementProps {
	primary?: boolean;
}

interface IProps extends IElementProps {
	icon: ReactNode;
	link: IEitherNavigationLink;
}

const style = css<IElementProps>`
	a {
		color: ${(props) => props.theme.colors.slateBlue};
		font-size: 12px;
		padding: 12px 10px 10px 10px;
		display: inline-block;
		text-align: center;
		text-decoration: none;
		transition: 70ms color ease-out;

		svg {
			transition: 70ms transform ease-out;
		}

		&:hover {
			color: ${(props) => props.theme.colors.antracite};

			svg {
				transform: translateY(-2px);
			}
		}

		@media screen and (min-width: 832px) and (max-width: 900px) {
			width: 54px;
		}

		${(props) =>
			props.primary
				? `
		color: ${props.theme.colors.white};
		background-color: ${props.theme.colors.primary};
		font-size: 10px;
		border-radius: 6px;
		line-height: 12px;
		padding: 6px;
		margin: 0 10px;
	`
				: ''}
	}
`;

const Element = styled(Link)<IElementProps>`
	${style}
`;

const AnchorElement = styled.a<IElementProps>`
	${style}
`;

const Wrapper = styled.span<IElementProps>`
	${style}
`;

const Icon = styled(Flex)`
	justify-content: center;
`;

export default function MainNavigationLink({ icon, primary, link }: IProps) {
	if (link.to != null) {
		return (
			<Wrapper primary={primary}>
				<Element to={link.to}>
					<Icon mb={1}>{icon}</Icon>

					{link.title}
				</Element>
			</Wrapper>
		);
	}

	return (
		<Wrapper primary={primary}>
			<AnchorElement href="#" onClick={link.onClick}>
				<Icon mb={1}>{icon}</Icon>

				{link.title}
			</AnchorElement>
		</Wrapper>
	);
}
